export default {
  name: 'SelectPageTag',
  props: {
    picked: Array,
    disabled: Boolean,
    placeholder: String
  },
  inject: ['renderCell'],
  render: function render(h) {
    var _this = this;

    var tags = [];
    if (this.picked.length) {
      this.picked.forEach(function (val, index) {
        var tag = [];
        // tag content
        tag.push(h('span', {
          domProps: {
            innerHTML: _this.renderCell(val)
          }
        }));
        if (!_this.disabled) {
          tag.push(h('span', {
            on: {
              click: function click(e) {
                e.stopPropagation();
                _this.remove(index);
              }
            }
          }, [h('i', { class: 'sp-iconfont sp-icon-close' })]));
        }
        tags.push(h('span', { class: 'sp-selected-tag', key: index }, tag));
      });
    } else {
      tags.push(h('span', { class: 'sp-placeholder' }, this.placeholder));
    }
    return h('div', { class: 'sp-base sp-inputs' }, tags);
  },

  methods: {
    remove: function remove(index) {
      this.$emit('remove', index);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/component/dic/components/Tag.js
// module id = 11
// module chunks = 0